import { Navigate, useLocation } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useSendTiktokCode } from '../../../apiHooks/mutations/integrationMutations/tiktokMutation';

const TiktokRoute = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const { mutate: sendFacebookCode } = useSendTiktokCode();

  useEffect(() => {
    if (codeParam) {
      sendFacebookCode(codeParam);
    }
  }, []);

  return <Navigate to="/dashboard" />;
};

export default TiktokRoute;
